import axios from "axios";
import config from "./config";

export const verifySoftwareToken = (body) => {
  return axios.post("/associate-software-token/verify-software-token", body, config);
};
